import {Directive, ElementRef, HostListener, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {MatMenuTrigger} from '@angular/material/menu';

@Directive({
	selector: '[matMenuTriggerFor][appToggleMenuOnHover]'
})
export class ToggleMenuOnHoverDirective implements OnInit, OnDestroy {

	#isInHoverBlock = false;
	#listenerDisposers: ListenerDisposer[] = [];

	constructor(private toggleElement: ElementRef,
							private menuTrigger: MatMenuTrigger,
							private renderer: Renderer2) {
	}

	@HostListener('pointerenter', ['$event'])
	triggerElementEnter(enterToggleElement: PointerEvent): void {

		if (enterToggleElement.pointerType !== 'mouse') {
			return;
		} // ignore touch or pen events

		this.setHoverState(true);

		this.menuTrigger.openMenu();

		const openMenu = this.menuTrigger.menu?.panelId ? document.getElementById(this.menuTrigger.menu.panelId) : undefined;

		if (!openMenu) {
			this.menuTrigger.closeMenu();
			return;
		}

		this.#listenerDisposers.push(this.renderer.listen(openMenu, 'pointerenter', (enterMenu: PointerEvent) => {
			if (enterMenu.pointerType !== 'mouse') {
				return;
			}
			this.setHoverState(true);
		}));

		this.#listenerDisposers.push(this.renderer.listen(openMenu, 'pointerleave', (leaveMenu: PointerEvent) => {
			if (leaveMenu.pointerType !== 'mouse') {
				return;
			}
			this.setHoverState(false);
		}));
	}

	@HostListener('pointerleave', ['$event'])
	triggerElementLeave(leaveToggleElement: PointerEvent): void {
		if (leaveToggleElement.pointerType !== 'mouse') {
			return;
		}
		this.setHoverState(false);
	}

	ngOnInit(): void {
		if(this.menuTrigger.menu) {
			this.menuTrigger.menu.hasBackdrop = false;
		}
	}

	ngOnDestroy(): void {
		this.disposeListeners();
	}

	private setHoverState(isInBlock: boolean): void {
		this.#isInHoverBlock = isInBlock;
		if (!isInBlock) {
			this.checkHover();
		}
	}

	private checkHover(): void {
		setTimeout(() => {
			if (!this.#isInHoverBlock && this.menuTrigger.menuOpen) {
				this.menuTrigger.closeMenu();
				this.disposeListeners();
			}
		}, 50);
	}

	private disposeListeners(): void {
		this.#listenerDisposers.forEach(unlisten => unlisten());
		this.#listenerDisposers = [];
	}
}

type ListenerDisposer = () => void;
